import { isRouteErrorResponse, useRouteError } from 'react-router'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { createLogger } from 'src/utils/logger'

const log = createLogger('ErrorPage')


const Root = styled('div')({
  flexGrow: 1,
  overflowY: 'auto',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
})

const MainContainer = styled(Container)(({ theme }) => ({
  padding: theme.spacing(4),
  textAlign: 'center',
}))

export default function ErrorPage() {
  const error = useRouteError()
  log.error(error)

  let errorMessage = 'An unexpected error has occurred.'
  if (isRouteErrorResponse(error)) {
    // error is type `ErrorResponse`
    errorMessage = error.statusText || error.data?.message || errorMessage
  } else if (error instanceof Error) {
    errorMessage = error.message
  } else if (typeof error === 'string') {
    errorMessage = error
  }

  return (
    <Root>
      <MainContainer maxWidth="sm">
        <Typography variant="h2" gutterBottom>
          Oops!
        </Typography>
        <Typography variant="h5" sx={{
          mt: 2
        }}>
          Sorry, something went wrong.
        </Typography>
        <Typography color="error" sx={{
          mt: 2
        }}>
          {errorMessage}
        </Typography>
        <Box sx={{
          mt: 4
        }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => window.location.reload()}
          >
            Reload Page
          </Button>
        </Box>
      </MainContainer>
    </Root>
  )
}
